var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
import React, { forwardRef, createRef, useLayoutEffect, useState, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import cx from 'classnames';
import { ThemeContext } from 'styled-components';
import { Container, Typography, Icon, CircleProgress } from '../';
import { getBPHelpers } from '../../utils/breakpoints';
import * as S from './styles';
import { iconNames } from '../Icon/types';
import { MEDIUM_WIDTH, MEDIUM_ICON_SIZE, MEDIUM_SPACING, LARGE_ICON_SIZE, LARGE_SPACING } from './settings';
export var Toolbox = forwardRef(function Toolbox(_a, ref) {
    var text = _a.text, icon = _a.icon, iconColor = _a.iconColor, circleProgressProps = _a.circleProgressProps, aspectRatioProp = _a.aspectRatio, size = _a.size, background = _a.background, backgroundStyles = _a.backgroundStyles, to = _a.to, onClick = _a.onClick, className = _a.className, style = _a.style, rest = __rest(_a, ["text", "icon", "iconColor", "circleProgressProps", "aspectRatio", "size", "background", "backgroundStyles", "to", "onClick", "className", "style"]);
    var wrapperRef = createRef();
    var theme = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(theme.breakpoints);
    var screenSize = BPHelpers.useScreenSize();
    var screenWidth = screenSize.width;
    var aspectRatio = {
        width: aspectRatioProp === null || aspectRatioProp === void 0 ? void 0 : aspectRatioProp.split(':')[0],
        height: aspectRatioProp === null || aspectRatioProp === void 0 ? void 0 : aspectRatioProp.split(':')[1]
    };
    var _b = useState(size === 'medium' ? MEDIUM_ICON_SIZE : LARGE_ICON_SIZE), iconSize = _b[0], setIconSize = _b[1];
    var _c = useState(size === 'medium' ? MEDIUM_SPACING : LARGE_SPACING), usedSpacing = _c[0], setUsedSpacing = _c[1];
    var isFluid = size === 'fluid';
    useLayoutEffect(function () {
        var _a;
        if (wrapperRef.current && isFluid) {
            if (((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) <= MEDIUM_WIDTH) {
                setIconSize(MEDIUM_ICON_SIZE);
                setUsedSpacing(MEDIUM_SPACING);
            }
            else {
                setIconSize(LARGE_ICON_SIZE);
                setUsedSpacing(LARGE_SPACING);
            }
        }
    }, [isFluid, wrapperRef, screenWidth, iconSize, usedSpacing]);
    var sizeClassName = size + "-size";
    var pointerClassName = onClick || to ? 'cursor-pointer' : false;
    var aspectRatioClassName = "aspect-ratio-" + aspectRatio.width + "-" + aspectRatio.height;
    var rootClass = cx(className, aspectRatioClassName, sizeClassName, pointerClassName);
    var contentStyles = background ? __assign({ backgroundImage: "url(" + background + ")" }, backgroundStyles) : {};
    var renderContent = (React.createElement(S.ToolboxContent, { onClick: onClick, ref: wrapperRef, style: contentStyles },
        React.createElement(Container, { flex: true, justifyContent: 'center', alignItems: 'center', direction: 'column', padded: usedSpacing },
            icon &&
                (typeof icon === 'string' && iconNames.includes(icon) ? (React.createElement(Icon, { name: icon, color: iconColor, size: iconSize })) : (icon)),
            text && (React.createElement(Container, { top: icon ? usedSpacing : undefined, flex: true, alignItems: 'center', justifyContent: 'center' }, typeof text === 'string' ? (React.createElement(Typography, { weight: 'medium', size: 'medium', align: 'center' }, text)) : (text))))));
    var resolveWrapper = to ? React.createElement(RouterLink, { to: to }, renderContent) : renderContent;
    return (React.createElement(S.Toolbox, __assign({ ref: ref, className: rootClass, style: style }, rest),
        resolveWrapper,
        circleProgressProps && (React.createElement(S.ProgressWrapper, null,
            React.createElement(CircleProgress, __assign({}, circleProgressProps, { size: 'xsmall' }))))));
});
Toolbox.defaultProps = {
    aspectRatio: '1:1',
    iconColor: 'grey',
    size: 'fluid'
};
Toolbox.displayName = 'Toolbox';
export default Toolbox;
//# sourceMappingURL=Toolbox.js.map